<template>
  <div class="w-full h-full">
    <!-- 暂时使用其他组件代替 -->
    <!-- <el-table
      ref="tableRef"
      height="calc(100% - 50px)"
      class="mt-10px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column width="50" :label="`${$t('序号')}`" type="index"></el-table-column>
      <el-table-column :label="`${$t('监控名称')}`" show-overflow-tooltip prop="deviceName">
      </el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="50" v-if="true">
        <template #default="{ row }">
          <div class="w-15px cursor-pointer text-[#00BCC8]" @click="lookDetail(row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getTableList()"
      :pager-count="5"
    >
    </el-pagination>
    <CameraPicture
      :deviceCode="deviceCode"
      :plid="plid"
      @refresh="isShowCameraDialog = false"
      v-if="isShowCameraDialog"
      class="w-970px h-500px"
    ></CameraPicture> -->
    <scameraList ref="scameraListRef" :labelList="labelList"></scameraList>
  </div>
</template>

<script>
const scameraList = () => {
  return import('../components/smartSecurity/scameraList')
}
// 暂时使用其他组件代替
// const CameraPicture = () => {
//   return import('../components/smartSecurity/cameraPicture')
// }
export default {
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  components: { scameraList },
  data() {
    return {
      keyWords: '',
      tableData: [],
      page: {
        total: 0,
        pageSize: 15,
        pageNo: 1,
      },
      isShowCameraDialog: false,
    }
  },
  methods: {
    async getTableList() {},
    lookDetail() {
      this.isShowCameraDialog = true
    },
  },
  mounted() {},
  beforeDestroy() {
    this.$refs.scameraListRef && this.$refs.scameraListRef.destroyAllLableOmitOne('')
  },
}
</script>

<style>
</style>
